export const removeClass = (list: HTMLElement[], className: string): void => {
    list.forEach((elem) => {
        elem.classList.remove(className);
    });
};
